import ErrorPage from 'next/error'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { NewsletterBlock } from '../../../../shared/blocks/NewsletterBlock'
import { PostAuthor } from '../../../../shared/components/blog/post/PostAuthor'
import PostBody from '../../../../shared/components/blog/post/PostBody'
import { PostFooter } from '../../../../shared/components/blog/post/PostFooter'
import PostHeader from '../../../../shared/components/blog/post/PostHeader'
import PostTilesListFull from '../../../../shared/components/blog/PostTilesListFull'
import { getAllPostsWithSlug, getPostAndMorePosts } from '../../../../shared/lib/api'
import { BlogContentList } from '../../../../shared/styles/blog/bloglist'
import { Container, ContainerContentNarrow } from '../../../../shared/styles/container'
import { device } from '../../../../shared/styles/device'
import PostEventBanner from '../../components/blog/PostEventBanner'
import { ActiveCampaignForm } from '../../components/global/ActivecampaignForm'
import Layout from '../../components/global/Layout'
import Seo from '../../components/global/Seo'

const BlogPostSection = styled.section`
  padding-top: 64px;
  padding-bottom: 64px;

  .component-content {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    @media ${device.tablet} {
      width: 576px;
    }
    @media ${device.laptop} {
      width: 653px;
    }
  }

  aside {
        padding-top: 52px;
        h2 {
        font-size: 32px;
        line-height: 1.125;
        font-weight: 800;
        margin-top: 0px;
        margin-bottom: 24px;
    }
  }
`;

export default function Post({ post, posts, preview }) {
  const router = useRouter()
  const morePosts = posts?.edges
  let postCategory = 'Update';
  const categories = post?.categories?.edges;
  if (categories != null && categories?.length > 0) {
    postCategory = categories[0]?.node?.name;
  }

  if (!router.isFallback && !post?.slug) {
    return <ErrorPage statusCode={404} />
  }

  const socialLinks = {
    facebook: "https://www.facebook.com/stellmichein/",
    instagram: "https://www.instagram.com/stellmichein/",
    linkedin: "https://www.linkedin.com/company/stell-mich-ein/"
  };

  return (
    <Layout preview={preview} showCallToAction={false}>
      <Container>
        <ContainerContentNarrow>
          {router.isFallback ? (
            <h1>Loading…</h1>
          ) : (
            <BlogPostSection>
              <article>
                <Seo
                  title={post.title}
                  description={post?.excerpt}
                  imageSrc={post.featuredImage?.node?.sourceUrl}
                />
                <PostHeader
                  title={post.title}
                  coverImage={post.featuredImage?.node}
                  date={post.date}
                  category={postCategory}
                  socialLinks={socialLinks}
                />
                <PostBody content={post.content} blocks={post.blocks} postEventBanner={<PostEventBanner />} />
                <PostFooter socialLinks={socialLinks} />
                <PostAuthor
                  author={post.author?.node}
                />
                <NewsletterBlock acForm={<ActiveCampaignForm />} smallPadding></NewsletterBlock>
              </article>
              <aside className='component-content'>
                <h2>Aktuelle News</h2>
                {morePosts.length > 0 &&
                  (
                    <BlogContentList role="list" singleCol>
                      <PostTilesListFull posts={morePosts} />
                    </BlogContentList>
                  )}
              </aside>
            </BlogPostSection>
          )}
        </ContainerContentNarrow>
      </Container>
    </Layout>
  )
}

export async function getStaticProps({ params, preview = false, previewData }) {
  const data = await getPostAndMorePosts(params.slug, preview, previewData)

  return {
    props: {
      preview,
      post: data.post,
      posts: data.posts,
    },
    revalidate: 120,
  }
}

export async function getStaticPaths() {
  const allPosts = await getAllPostsWithSlug()

  return {
    paths: allPosts.edges.map(({ node }) => `/blog/${node.slug}`) || [],
    fallback: 'blocking'
  }
}
